import { UserAttributesClient } from 'frontend-preferences-client';
const userAttributesClient = UserAttributesClient.forCaller('ContentEmailUI');
export const HAS_DISMISSED_MOBILE_BANNER_KEY = 'hasDismissedMobileBanner';
export const MOBILE_BANNER_VIEW_TIMES = 'mobileBannerViewTimes';
export const HAS_USED_AI_TRANSLATION_KEY = 'hasUsedAiTranslation';
export function setUserAttributeRequest(attributeName, attributeValue) {
  return userAttributesClient.write(attributeName, String(attributeValue));
}
export function getUserAttributeRequest(key) {
  return userAttributesClient.fetch(key, 'false');
}
export function getUserAttributesRequest({
  keys
}) {
  const fetchBody = keys.reduce((acc, key) => {
    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return Object.assign({}, acc, {
      [key]: ''
    });
  }, {});
  return userAttributesClient.batchFetch(fetchBody);
}
export function updateUserHasDismissedMobileBannerRequest() {
  return userAttributesClient.write(HAS_DISMISSED_MOBILE_BANNER_KEY, 'true');
}
export function updateMobileBannerViewTimes(count) {
  return userAttributesClient.write(MOBILE_BANNER_VIEW_TIMES, String(count));
}